var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInverseIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.066,
    height: 20.066,
    viewBox: "0 0 20.066 20.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5144",
    "data-name": "Rectangle 5144",
    width: 20.066,
    height: 20.066,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9580",
    "data-name": "Group 9580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9579",
    "data-name": "Group 9579",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27499",
    "data-name": "Path 27499",
    d: "M10.033,20.066A10.033,10.033,0,1,1,20.066,10.033,10.045,10.045,0,0,1,10.033,20.066m0-17.94a7.906,7.906,0,1,0,7.906,7.907,7.916,7.916,0,0,0-7.906-7.907",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27500",
    "data-name": "Path 27500",
    d: "M10.033,4.033a1,1,0,0,0-1,1v10a.99.99,0,0,0,1,1,6,6,0,1,0,0-12m0,0a1,1,0,0,0-1,1v10a.99.99,0,0,0,1,1,6,6,0,1,0,0-12",
    fill: "#991F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverseIconSelected);
export default __webpack_public_path__ + "static/media/InverseIconSelected.dd6746c0733665009b5bc126400df2cd.svg";
export { ForwardRef as ReactComponent };